import { TeamRepository } from "../data/TeamRepository";

const teamRepository = new TeamRepository();

export const getScores = async (challengeUuid: string) => {
  const scores = await teamRepository.fetchTeamScores(challengeUuid);

  return scores;
}